import React from 'react';
import { Box, Typography } from '@mui/material';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import { getRegionLocation, RegionLocationInput } from '../utils/regionLocation';

/** Location first, exact deployment identifier second. No hover required. */
export default function RegionLocation({ region, compact = false }: {
  region: RegionLocationInput; compact?: boolean;
}) {
  const place = getRegionLocation(region);
  return <Box component="span" sx={{ display: 'inline-flex', alignItems: 'flex-start', gap: 0.75, minWidth: 0, maxWidth: '100%', verticalAlign: 'middle', textAlign: 'left' }}>
    {!compact && <PlaceOutlinedIcon aria-hidden="true" sx={{ fontSize: 17, mt: 0.25, color: 'text.secondary', flexShrink: 0 }} />}
    <Box component="span" sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>
      <Typography component="span" variant="body2" sx={{ display: 'block', fontWeight: 500, color: 'text.primary', lineHeight: 1.4 }}>{place.label}</Typography>
      {(place.label !== place.code || place.isLocalZone) && <Typography component="span" variant="caption" sx={{ display: 'block', color: 'text.secondary', lineHeight: 1.5 }}>
        <Box component="span" sx={{ fontFamily: 'monospace' }}>{place.code}</Box>
        {place.isLocalZone && <Box component="span" sx={{ ml: 0.75 }}>· Local Zone</Box>}
      </Typography>}
      {!compact && place.parentCode && <Typography component="span" variant="caption" sx={{ display: 'block', color: 'text.secondary' }}>
        Parent: {getRegionLocation(place.parentCode).label} · {place.parentCode}
      </Typography>}
    </Box>
  </Box>;
}
